module.exports = __webpack_public_path__ + "img/Back End.0dd912c7.png";